export enum DashboardContabilDITypes {
  RECEITA_FEDERAL_SERVICE = "RECEITA_FEDERAL_SERVICE"
}
